import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import CarListingsPage from "./pages/CarListingsPage";
import CarDetailPage from "./pages/CarDetailPage";
import SellCarPage from "./pages/SellCarPage";
import ContactUsPage from "./pages/ContactUsPage";
import Cars from "./components/Cars";
import Profile from "./components/Profile";
import Reviews from "./pages/Reviews";



function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      <Routes>
        <Route path="/" element={<HomePage isAuthenticated={isAuthenticated} />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/usedcars" element={<CarListingsPage />} />
        <Route path="/cars/:id" element={<CarDetailPage />} />
        <Route path="/sell-car" element={<SellCarPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/cars" element={<Cars />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/reviews" element={<Reviews />} />
      </Routes>
    </Router>
  );
}

export default App;
